// extracted by mini-css-extract-plugin
export default {"custom-checkbox":"checkbox_custom-checkbox__WQwlk","small":"checkbox_small__WNE6p","green":"checkbox_green__wNxVC","lightgreen":"checkbox_lightgreen__tPRrm"};